import {
  styled,
  Table,
  TableCell,
  tableCellClasses,
  TableRow,
} from "@mui/material";
import React from "react";
import { CustomPaper, CustomTableContainer } from "./Calendar";

type TableProps = {
  isFullWidth?: boolean;
  bordered?: boolean;
  highlightFirstColumn?: boolean;
  hoverable?: boolean;
  navHeight?: string;
  height?: string;
  children: React.ReactNode;
};
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#090a14",
    color: "white",
    fontFamily: "Inter",
  },
  [`&.${tableCellClasses.body}`]: {
    color: "white",
    borderBottom: "1px solid #3C406C",
    fontFamily: "Inter",
  },
}));

export const StyledTableRow = styled(TableRow)(() => ({
  "&:hover": {
    background:
      "linear-gradient(90deg, rgb(176, 52, 52) 0%, rgb(24, 75, 104) 118.29%) !important",
    cursor: "pointer",
    fontFamily: "Inter",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
    fontFamily: "Inter",
  },
}));
function TableComponent(props: TableProps) {
  const { navHeight, children, height } = props;
  return (
    <CustomPaper
      sx={{
        width: "100%",
        background: "transparent",
        color: "white",
        height: height ? height : "",
      }}
    >
      <CustomTableContainer
        navHeight={navHeight || ""}
        height={height || ""}
        className="visible-scrollbar"
      >
        <Table stickyHeader aria-label="sticky table">
          {children}
        </Table>
      </CustomTableContainer>
    </CustomPaper>
  );
}
// const Table = styled.table<TableProps & React.HTMLProps<HTMLTableElement>>`
//   overflow: auto;
//   ${({ isFullWidth }) => (isFullWidth ? 'width: 100%;' : 'width: 0px;')};
//   border-spacing: 0;
//   border-collapse: collapse;

//   & > thead > tr:first-child {
//     td,
//     th {
//       padding-top: 0;
//     }
//   }

//   & > tbody:first-child > tr:first-child {
//     td,
//     th {
//       padding-top: 0;
//     }
//   }

//   td {
//     vertical-align: baseline;
//   }

//   th {
//     vertical-align: bottom;
//   }

//   td,
//   th {
//     padding: ${({ theme }) => theme.spacing.x1}
//       ${({ theme }) => theme.spacing.x1};
//     margin: 0;
//     text-align: left;

//     ${({ theme, isFullWidth }) =>
//       !isFullWidth &&
//       `
//     min-width: ${theme.spacing.base * 8}px;
//     white-space: nowrap;
//     `};

//     color: ${({ theme }) => theme.color.textColor};
//     ${({ theme, bordered }) =>
//       bordered
//         ? `border: 1px solid ${theme.color.borderColor};`
//         : `border-bottom: 1px solid ${theme.color.borderColor};`}

//     &:first-child {
//       ${({ theme, highlightFirstColumn }) =>
//         highlightFirstColumn &&
//         `background-color: ${theme.color.lightBackground};`}
//       padding-left: 0;
//     }

//     &:last-child {
//       padding-right: 0;
//     }
//   }

//   thead th {
//     color: ${({ theme }) => theme.color.textColor};
//     ${({ theme, bordered }) =>
//       bordered
//         ? `border: 1px solid ${theme.color.borderColor};`
//         : `border-bottom: 1px solid ${theme.color.primary};`}
//   }

//   td.nowrap {
//     white-space: nowrap;
//   }

//   tbody tr:hover {
//     ${({ hoverable, theme }) =>
//       hoverable &&
//       css`
//         background-color: ${theme.color.lightBackground};
//         cursor: pointer;
//       `};
//   }
// `;

// Table.defaultProps = {
//   isFullWidth: true,
// };

export default TableComponent;
